import { ChatActionCentreSlider } from "components/ChannelinfoSlider/ChannelInfo/ActionCentre/ChatActionCentreSlider";
import { UnstyledChannel } from "components/UnstyledChannel/UnstyledChannel";
import { useMemo } from "react";
import { useChatContext } from "stream-chat-react";

export const TaskActionDetails = ({
  channelId,
  handleSliderClose,
}: {
  channelId: string;
  handleSliderClose?: () => void;
}) => {
  const { client } = useChatContext();
  const channel = useMemo(() => {
    return client.channel("messaging", channelId);
  }, [channelId]);

  return (
    <UnstyledChannel channel={channel} fullheight>
      <ChatActionCentreSlider
        withSlider={false}
        handleSliderClose={handleSliderClose}
      />
    </UnstyledChannel>
  );
};
